import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent } from "vue"

const _hoisted_1 = { class: "v-home" }

import {onMounted, ref} from "vue";
import {checkout} from "@/utils/checkout";
import {XHR} from "@/utils/xhr";
import {router} from "@/router";
import Hero from '@/components/home/hero.vue'
import Features from '@/components/home/features.vue'
import Showcase from '@/components/home/showcase.vue'
import HomeFaq from '@/components/home/home-faq.vue'
import PricingPlans from "@/components/pricing/plans.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'home',
  setup(__props) {

const version = ref(0)


checkout.on_change = () => {
  version.value ++
}

onMounted(() => {
  const xhr = new XHR()
  xhr.get('/login-verify').then(x => {
    if (x.data === '1') {
      router.push('/dash')
    }
  })
})


return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(Hero),
    _createVNode(Features),
    _createVNode(Showcase),
    (_openBlock(), _createElementBlock("div", {
      class: "section container pricing home-pricing",
      key: version.value
    }, [
      (_unref(checkout).trial_price)
        ? (_openBlock(), _createBlock(PricingPlans, { key: 0 }))
        : _createCommentVNode("", true)
    ])),
    _createVNode(HomeFaq),
    _createVNode(_component_router_view)
  ]))
}
}

})